import isNil from 'lodash/isNil';
import type { ApiGetWorkflowResponseWithUsages } from '@jira/project-settings__workflow-types/src/workflowTypes.types.tsx';
import { performPostRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';

type CloudId = string;

export const getApiPrefix = () => 'gateway/api/jira/project-configuration';

export const constructEndpoint = (cloudId: string) =>
	`/${getApiPrefix()}/query/${cloudId}/3/workflow`;

type WorkflowIdentifier = {
	workflowId?: string;
	workflowName?: string;
	projectAndIssueType?: {
		projectId: string;
		issueTypeId: string;
	};
	projectKeyAndIssueType?: {
		projectKey: string;
		issueTypeId: string;
	};
};

type GetWorkflowPayload = {
	workflowIds?: [string];
	workflowNames?: [string];
	projectAndIssueTypes?: [
		{
			projectId: string;
			issueTypeId: string;
		},
	];
	projectKeyAndIssueTypes?: [
		{
			projectKey: string;
			issueTypeId: string;
		},
	];
	skipUsageLookup?: boolean;
	checkForDrafts?: boolean;
	getDrafts?: boolean;
};

export type GetWorkflowConfigOptions = { checkForDrafts?: boolean; getDrafts?: boolean };

export const getWorkflow = (
	cloudId: CloudId,
	workflowIdentifier: WorkflowIdentifier,
	config?: GetWorkflowConfigOptions,
): Promise<ApiGetWorkflowResponseWithUsages> => {
	const url = constructEndpoint(cloudId);
	const { workflowId, workflowName, projectAndIssueType, projectKeyAndIssueType } =
		workflowIdentifier;

	const payload: GetWorkflowPayload = {
		skipUsageLookup: false,
	};

	if (!isNil(workflowId)) {
		payload.workflowIds = [workflowId];
	}

	if (!isNil(workflowName)) {
		payload.workflowNames = [workflowName];
	}

	if (!isNil(projectAndIssueType)) {
		payload.projectAndIssueTypes = [projectAndIssueType];
	}
	if (!isNil(projectKeyAndIssueType)) {
		payload.projectKeyAndIssueTypes = [projectKeyAndIssueType];
	}

	if (config?.checkForDrafts) {
		payload.checkForDrafts = true;
	}

	if (config?.getDrafts) {
		payload.getDrafts = true;
	}

	return performPostRequest(url, {
		body: JSON.stringify(payload),
	});
};
